import { render } from "./ModalService.vue?vue&type=template&id=07277409&scoped=true"
import script from "./ModalService.vue?vue&type=script&lang=js"
export * from "./ModalService.vue?vue&type=script&lang=js"

import "./ModalService.vue?vue&type=style&index=0&id=07277409&lang=scss&scoped=true"

import exportComponent from "/var/www/development/hai-parahita-dev.aksamedia.co.id/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07277409"]])

export default __exports__